define(

    'NetSuite.Slideshow.SlideshowCCT',

    [
        'NetSuite.Slideshow.SlideshowCCT.View'
    ],

    function (
        SlideshowCCTView
    ) {
        'use strict';
        return {
            mountToApp: function mountToApp(container) {
                container.getComponent('CMS').registerCustomContentType({
                    id: 'cct_netsuite_slideshowcct',
                    view: SlideshowCCTView,
                    options: {
                        container: container
                    }
                });
            }
        };
    });
